import React, { useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import RejectPaymentModal from "../../payments/components/RejectPaymentModal";
import toast from "react-hot-toast";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import { ApprovePaymentApi } from "../../../api/request/report";
import { useNavigate, useParams } from "react-router-dom";

const CheckPaymentModal = ({
  isOpen,
  setIsOpen,
  paymentType,
  fileData,
  getFileDetails = () => {},
}) => {
  const navigate = useNavigate();
  const { fileTypeId } = useParams();
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isApproveLoading, setIsApproveLoading] = useState(false);

  let modalTitle = "";

  if (paymentType === "check") {
    modalTitle = "Check Payment";
  } else if (paymentType === "reject") {
    modalTitle = "Payment Rejected";
  } else if (paymentType === "done") {
    modalTitle = "Payment Received";
  }

  const handleApprove = async () => {
    setIsApproveLoading(true);
    try {
      const { data } = await ApprovePaymentApi({
        file_id: fileData?.payment_history[0]?.file_id,
      });
      if (data?.status) {
        toast.success(data?.message);
        setIsApproveModalOpen(false);
        setIsOpen(false);
        navigate(`/file/${fileTypeId}`, {
          state: { task: fileData?.running_task_name },
        });
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsApproveLoading(false);
    }
  };

  const handleReject = () => {
    setIsOpen(false);
    setIsRejectModalOpen(true);
  };
  return (
    <>
      <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title={modalTitle}>
        <div className="flex justify-center">
          <div className="grid gap-6 sm:grid-cols-2 w-full max-w-md">
            <div>
              <p className="text-base font-semibold text-gray-800">File Name</p>
              <p className="capitalize text-gray-600 break-words">
                {fileData?.service_name_slug}
              </p>
            </div>
            <div>
              <p className="text-base font-semibold text-gray-800">File No.</p>
              <p className="text-gray-600">#{fileData?.file_number}</p>
            </div>
            <div>
              <p className="text-base font-semibold text-gray-800">
                Interac Email
              </p>
              <p className="text-gray-600 break-words">
                {fileData?.interac_email}
              </p>
            </div>
            <div>
              <p className="text-base font-semibold text-gray-800">
                Total Amount
              </p>
              <p className="text-gray-600">
                ${fileData?.payment_history[0]?.amount}
              </p>
            </div>
          </div>
        </div>
        {fileData?.payment_history[0]?.reason !== null ? (
          <div className="mt-5">
            <p className="text-base font-semibold text-gray-800">
              Rejected Reason
            </p>
            <p
              className="text-gray-600 w-[500px] truncate"
              title={fileData?.payment_history[0]?.reason}
            >
              {fileData?.payment_history[0]?.reason}
            </p>
          </div>
        ) : (
          ""
        )}

        <div className="flex justify-center gap-3 mt-5">
          {paymentType === "check" ? (
            <>
              <LoadableButton
                lable="Approve"
                className="!px-3 !text-sm w-[100px] !bg-green-500"
                onClick={() => {
                  setIsApproveModalOpen(true);
                  setIsOpen(false);
                }}
              />
              <LoadableButton
                lable="Reject"
                className="!px-3 !text-sm w-[100px] !bg-red-500"
                onClick={() => handleReject()}
              />
            </>
          ) : (
            <LoadableButton
              lable="OK"
              className="!px-3 !text-sm w-[90px]"
              onClick={() => setIsOpen(false)}
            />
          )}
        </div>
      </ModalComponent>

      <RejectPaymentModal
        isOpen={isRejectModalOpen}
        setIsOpen={setIsRejectModalOpen}
        payment={fileData?.payment_history[0]}
        getFileDetails={() => getFileDetails()}
      />

      <ConfirmationModal
        type={"success"}
        isOpen={isApproveModalOpen}
        setIsOpen={setIsApproveModalOpen}
        message={`Are you sure you want to approve this payment?`}
        onConfirm={handleApprove}
        isLoading={isApproveLoading}
        loadingLabel={`Approving payment...`}
      />
    </>
  );
};

export default CheckPaymentModal;
